export function showNotification(type, message) {
    console.log(`Notification: ${type} - ${message}`);
    
    // Créer le conteneur de toast s'il n'existe pas
    let toastContainer = document.querySelector('.toast-container');
    if (!toastContainer) {
        toastContainer = document.createElement('div');
        toastContainer.className = 'toast-container position-fixed bottom-0 end-0 p-3';
        document.body.appendChild(toastContainer);
    }
    
    // Créer le toast
    const toastId = 'toast-' + Date.now();
    const toastEl = document.createElement('div');
    toastEl.className = `toast align-items-center border-0 bg-${type === 'success' ? 'success' : 'danger'}`;
    toastEl.setAttribute('id', toastId);
    toastEl.setAttribute('role', 'alert');
    toastEl.setAttribute('aria-live', 'assertive');
    toastEl.setAttribute('aria-atomic', 'true');
    
    toastEl.innerHTML = `
        <div class="d-flex">
            <div class="toast-body text-white">${message}</div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Fermer"></button>
        </div>
    `;
    
    toastContainer.appendChild(toastEl);
    
    // Initialiser avec Bootstrap
    try {
        if (typeof bootstrap !== 'undefined') {
            const toastInstance = new bootstrap.Toast(toastEl, {
                autohide: false
            });
            toastInstance.show();
        } else {
            console.warn('Bootstrap non disponible, mode dégradé');
            toastEl.style.display = 'block';
            toastEl.style.opacity = '1';
            
            const closeButton = toastEl.querySelector('.btn-close');
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    toastEl.remove();
                    if (toastContainer.children.length === 0) {
                        toastContainer.remove();
                    }
                });
            }
        }
    } catch (error) {
        console.error('Erreur toast:', error);
    }
}

/**
 * Stocke une notification pour l'afficher après le rechargement de la page
 * @param {string} type - Le type de notification ('success', 'error', etc.)
 * @param {string} message - Le message à afficher
 */
export function storeNotification(type, message) {
    try {
        // Récupérer les notifications existantes ou créer un tableau vide
        let notifications = [];
        const existingNotifications = localStorage.getItem('gobooking_notifications');
        
        if (existingNotifications) {
            try {
                notifications = JSON.parse(existingNotifications);
                // S'assurer que c'est un tableau
                if (!Array.isArray(notifications)) {
                    notifications = [];
                }
            } catch (e) {
                console.error('Erreur lors du parsing des notifications:', e);
                notifications = [];
            }
        }
        
        // Ajouter la nouvelle notification
        notifications.push({
            type,
            message,
            timestamp: Date.now()
        });
        
        // Stocker le tableau de notifications
        localStorage.setItem('gobooking_notifications', JSON.stringify(notifications));
        console.log('Notification stockée:', { type, message });
    } catch (error) {
        console.error('Erreur lors du stockage de la notification:', error);
    }
}

/**
 * Récupère et supprime les notifications stockées
 * @returns {Array} Les notifications stockées
 */
export function retrieveNotifications() {
    try {
        // Récupérer les notifications depuis localStorage
        const notificationsStr = localStorage.getItem('gobooking_notifications');
        if (!notificationsStr) return [];
        
        // Supprimer les notifications du stockage
        localStorage.removeItem('gobooking_notifications');
        
        // Parser et retourner les notifications
        const notifications = JSON.parse(notificationsStr);
        
        // Vérifier si c'est un tableau
        if (!Array.isArray(notifications)) {
            return [];
        }
        
        // Filtrer les notifications trop anciennes (plus de 1 minute)
        const maxAge = 60 * 1000; // 1 minute en millisecondes
        const validNotifications = notifications.filter(notification => {
            return (Date.now() - notification.timestamp) <= maxAge;
        });
        
        return validNotifications;
    } catch (error) {
        console.error('Erreur lors de la récupération des notifications:', error);
        return [];
    }
}

/**
 * Affiche les notifications stockées
 * À appeler au chargement de la page
 */
export function showStoredNotifications() {
    const notifications = retrieveNotifications();
    if (notifications.length > 0) {
        // Attendre un peu pour laisser la page se charger complètement
        setTimeout(() => {
            notifications.forEach(notification => {
                showNotification(notification.type, notification.message);
            });
        }, 500);
    }
}

// Vérifier et afficher les notifications stockées au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
    showStoredNotifications();
});

// Pour rétrocompatibilité avec le code existant
export function retrieveNotification() {
    const notifications = retrieveNotifications();
    return notifications.length > 0 ? notifications[0] : null;
}

export function showStoredNotification() {
    showStoredNotifications();
}
